import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import H8View from './components/H8View';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Dashboard/Profile';
import Plan from './pages/Dashboard/Plan';
import Header from './components/Header';

/**
 * H8 엔진 전용 앱
 * 완벽한 품질 모드 (8가지 타입)
 */
function AppContent() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  
  // Don't show header on login/signup pages
  const hideHeaderPaths = ["/login", "/signup"];
  const isHeaderHidden = hideHeaderPaths.includes(location.pathname);
  
  return (
    <div className="h-screen">
      {isAuthenticated && !isHeaderHidden && <Header />}
      <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route 
                  path="/h8" 
                  element={
                    <ProtectedRoute>
                      <H8View />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/dashboard/profile" 
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/dashboard/plan" 
                  element={
                    <ProtectedRoute>
                      <Plan />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/" element={<Navigate to="/h8" replace />} />
                <Route path="*" element={<Navigate to="/h8" replace />} />
      </Routes>
      <Toaster position="top-right" />
    </div>
  );
}

function AppH8() {
  return (
    <AuthProvider>
      <AppProvider>
        <Router>
          <AppContent />
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="flex items-center justify-center h-screen">로딩 중...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

export default AppH8;